module.exports = __webpack_public_path__ + "img/ترمینال.ed321362.png";